import React from "react";
import { UserDto } from "../../../Types/GroupServiceTypes";
import { Button } from "../../../Components/Button";
import { AdminIcon } from "../../../Icons/AdminIcon";
import { GroupService } from "../../../DataService/GroupService";
import '../AdminGroups.css'

interface Props {
  members: UserDto[];
  groupId: string;
  onRefresh: () => void;
}

const MembersList: React.FC<Props> = ({ members, groupId, onRefresh }) => {
  const remove = async (userId: string) => {
    await GroupService.RemoveUserFromGroup(groupId, userId);
    onRefresh();
  };

  return (
    <div>
      {members.map(m => (
        <div key={m.id} className="admin-groups-flex-items-center-justify-between-p-2-bg-gray-50-rounded" style={{ marginBottom: 8 }}>
          <div>
            <p className="text-sm-font-medium">{m.name}</p>
            <p className="text-xs-text-gray-500">{m.email}</p>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <Button
              className="warning-button admin-groups-member-delete-button"
              onClick={() => remove(m.id)}
              aria-label={`Ta bort ${m.name}`}
              text={<AdminIcon.Trashcan width={16} height={16} fill="white" />}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default MembersList;
